import { DATE_INPUT_CONSTANTS } from '../../utils'
import { CustomCalendarContainerPropsType } from '../../utils/types'

export const CustomCalendarContainer = ({
  className,
  children,
  onClear,
  onTodayClick,
  showClear = true,
}: CustomCalendarContainerPropsType) => {
  const wrapperClassName = [
    className,
    'customwrapper relative flex flex-col z-[9999] bg-white shadow-md rounded-lg',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={wrapperClassName}>
      <div>{children}</div>
      <div className="flex justify-around gap-2 mt-2 border-t p-2">
        <button
          type="button"
          className="text-xs text-blue-600"
          onClick={onTodayClick}
        >
          {DATE_INPUT_CONSTANTS.TODAY}
        </button>
        {showClear && (
          <button
            type="button"
            className="text-xs text-red-600"
            onClick={onClear}
          >
            {DATE_INPUT_CONSTANTS.CLEAR}
          </button>
        )}
      </div>
    </div>
  )
}
